import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const Poster = () => import('../views/sports-meeting/Poster.vue')
const CreateStep1 = () => import('../views/sports-meeting/Step1.vue')
const CreateStep2 = () => import('../views/sports-meeting/Step2.vue')
const CreateStep3 = () => import('../views/sports-meeting/Step3.vue')
const GameDetailCheck = () => import('../views/sports-meeting/GameDetailOfCheck.vue')
const GameDetailUpdate = () => import('../views/sports-meeting/GameDetailOfUpdate.vue')
const TemplateList = () => import('../views/sports-meeting/TemplateList.vue')
const TemplateCreate = () => import('../views/sports-meeting/TemplateCreate.vue')
const TemplateBaseInfo = () => import('../views/sports-meeting/TemplateBaseInfo.vue')

const Autumn2023landing = () => import('../views/sports-meeting/Autumn2023Landing.vue')

export const posterRoute: RouteConfig = {
  path: '/sports-meeting-poster',
  name: 'sports_meeting_poster',
  component: Poster,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '比赛预览',
  },
}

export const createStep1Route: RouteConfig = {
  path: '/sports-meeting-2022-step1',
  name: 'sports_meeting_step1',
  component: CreateStep1,
  meta: {
    stepTitle: '选择项目',
    title: '创建运动会',
    nextStep: 'sports_meeting_step2',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
  props: (route) => ({
    currentStep: Number(route.query.currentStep),
    totalSteps: Number(route.query.totalSteps),
  }),
}

export const createStep2Route: RouteConfig = {
  path: '/sports-meeting-2022-step2',
  name: 'sports_meeting_step2',
  component: CreateStep2,
  meta: {
    stepTitle: '奖项设置',
    title: '创建运动会',
    nextStep: 'sports_meeting_step3',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
  props: (route) => ({
    currentStep: Number(route.query.currentStep),
    totalSteps: Number(route.query.totalSteps),
  }),
}

export const createStep3Route: RouteConfig = {
  path: '/sports-meeting-2022-step3',
  name: 'sports_meeting_step3',
  component: CreateStep3,
  meta: {
    stepTitle: '设置基础信息',
    title: '创建运动会',
    nextButtonText: '确定创建',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
  props: (route) => ({
    currentStep: Number(route.query.currentStep),
    totalSteps: Number(route.query.totalSteps),
  }),
}

export const gameDetailCheckRoute: RouteConfig = {
  path: '/sports-meeting-game-detail-check',
  name: 'sports_meeting_game_detail_check',
  component: GameDetailCheck,
  props: (route) => ({ ...route.query, ...route.params, index: Number(route.query.index) }),
  meta: {
    title: '比赛详情',
    ignoreLogin: true,
  },
}

export const gameDetailUpdateRoute: RouteConfig = {
  path: '/sports-meeting-game-detail-update',
  name: 'sports_meeting_game_detail_update',
  component: GameDetailUpdate,
  props: (route) => ({ ...route.query, ...route.params, index: Number(route.query.index) }),
  meta: {
    title: '比赛详情',
  },
}

export const templateListRoute: RouteConfig = {
  path: '/sports-meeting-template-list',
  name: 'sports_meeting_template_list',
  component: TemplateList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '创建运动会',
    ignoreLogin: true,
  },
}

export const templateCreateRoute: RouteConfig = {
  path: '/sports-meeting-template-create',
  name: 'sports_meeting_template_create',
  component: TemplateCreate,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '创建运动会',
    ignoreLogin: true,
  },
}

export const templateBaseInfoRoute: RouteConfig = {
  path: '/sports-meeting-template-base-info',
  name: 'sports_meeting_template_base_info',
  component: TemplateBaseInfo,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '创建运动会',
  },
}

export const Autumn2023LandingRoute: RouteConfig = {
  path: '/sports-meeting-autumn-2023-landing',
  name: 'sports_meeting_autumn_2023_landing',
  component: Autumn2023landing,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '线上运动会开展神器',
    ignoreLogin: true,
  },
}

export default [
  posterRoute,
  createStep1Route,
  createStep2Route,
  createStep3Route,
  gameDetailCheckRoute,
  gameDetailUpdateRoute,
  templateListRoute,
  templateCreateRoute,
  templateBaseInfoRoute,
  Autumn2023LandingRoute,
]

export function navigateToSportsMeetingPoster(router: VueRouter, id: string) {
  router.push({ name: posterRoute.name, query: { id } })
}
